import { createTheme } from '@mantine/core';

import type { MantineColorsTuple } from "@mantine/core"

const brandGreen: MantineColorsTuple = [
  "#f4f6f0", // 0 — off-white with green tint
  "#dce8d8", // 1 — very light sage
  "#c2d9bc", // 2
  "#a8c48a", // 3 — pale sage / sparkle highlight
  "#8aab80", // 4 — light sage
  "#6B8F5E", // 5 — sage body
  "#4E6C42", // 6 — cactus mid (primary)
  "#3A5430", // 7 — cactus dark
  "#293D22", // 8 — deep green
  "#1C2E1A", // 9 — deep spine / darkest
]

export const palette = {
  background: { light: "#f4f6f0", dark: "#161E15" },
  text:       { light: "#2a3828", dark: "#dce8d8" },
  title:      { light: "#6B8F5E", dark: "#a8c48a" },
  subtitle:   { light: "#3A5430", dark: "#8aab80" },
  border:     { light: "#d4e4d0", dark: "#3A5430" },
  footerText: { light: "#8aab80", dark: "#7a9a73" },
}

export const theme = createTheme({
  primaryColor: "brand",
  primaryShade: { light: 6, dark: 4 },
  colors: {
    brand: brandGreen,
  },
  fontFamily: "'Aleo', serif",
  headings: {
    fontFamily: "'Aleo', serif",
    fontWeight: "300",
  },
  defaultRadius: "sm",
})
